import React from 'react';
import './Cali.css'; 

const Tumaco = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
      <h1><a className='Titulo' href="/aip/SKCO.pdf" target="_blank" rel="noreferrer">Aeropuerto La Florida</a></h1>
    </div>
    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 06</th>                     
          </tr>         
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/ENSO4B.pdf" target="_blank" rel="noreferrer">ENSO4B</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/ENSO4B.pdf" target="_blank" rel="noreferrer">EGOB1L</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/ENSO4B.pdf" target="_blank" rel="noreferrer">GIBT2A</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/ENSO4B.pdf" target="_blank" rel="noreferrer">TUNG1E</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/ENSO4B.pdf" target="_blank" rel="noreferrer">XOKI2B</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/TUNG1A.pdf" target="_blank" rel="noreferrer">TUNG1A</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/TUNG1A.pdf" target="_blank" rel="noreferrer">XOKI1D</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/ANGE1A.pdf" target="_blank" rel="noreferrer">ANGE1A</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/ANGE1A.pdf" target="_blank" rel="noreferrer">EGOB1G</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/ANGE1A.pdf" target="_blank" rel="noreferrer">ENSO1C</a></th>
          </tr>
          
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 24</th>                      
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/TCO4A.pdf" target="_blank" rel="noreferrer">TCO4A</a></th>
          </tr>
         <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/TCO4A.pdf" target="_blank" rel="noreferrer">ANGE1C</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/TCO4A.pdf" target="_blank" rel="noreferrer">ENSO4A</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/TUNG1B.pdf" target="_blank" rel="noreferrer">TUNG1B</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/TUNG1B.pdf" target="_blank" rel="noreferrer">XOKI1E</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/ANGE1B.pdf" target="_blank" rel="noreferrer">ANGE1B</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/ANGE1B.pdf" target="_blank" rel="noreferrer">EGOB1H</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKCO/ANGE1B.pdf" target="_blank" rel="noreferrer">ENSO1D</a></th>
          </tr>
            </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 06</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCO/EGOB1J.pdf" target="_blank" rel="noreferrer">EGOB1J</a></th>
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCO/EGOB1J.pdf" target="_blank" rel="noreferrer">GIBT1G</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCO/EGOB1J.pdf" target="_blank" rel="noreferrer">TUNG1C</a></th>
          </tr>       
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 24</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCO/GIBT2B.pdf" target="_blank" rel="noreferrer">GIBT2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCO/GIBT2B.pdf" target="_blank" rel="noreferrer">XOKI2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCO/EGOB1K.pdf" target="_blank" rel="noreferrer">EGOB1K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCO/EGOB1K.pdf" target="_blank" rel="noreferrer">GIBT1H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCO/EGOB1K.pdf" target="_blank" rel="noreferrer">TUNG1D</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 06</th>                      
          </tr>   
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCO/RNP06.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>       
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 24</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCO/VORZ24.pdf" target="_blank" rel="noreferrer">VOR Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCO/VORY24.pdf" target="_blank" rel="noreferrer">VOR Y</a></th>
          </tr>
           <tr>
            <th className='Procedimientos'><a href="/regionales/SKCO/RNP24.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Tumaco;